var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canDisplayTitle)?_c('popover',{attrs:{"content":_vm.title,"trigger":_vm.triggerTooltip}},[_c('button',{class:_vm.classObject,style:(_vm.styleObject),domProps:{"textContent":_vm._s(_vm.value)},on:{"click":_vm.save}})]):_c('button',{class:_vm.classObject,style:(_vm.styleObject),domProps:{"textContent":_vm._s(_vm.value)},on:{"click":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }